import type { ParseKeys } from 'i18next';
import type { UserId, ViewModelIndividualPermissionRoleJSON } from 'balus-common';

type ViewModelIndividualPermissionRolesJSON = Record<UserId, ViewModelIndividualPermissionRoleJSON>;

export class ViewModelIndividualPermissions {
  static Locales: Record<ViewModelIndividualPermissionRoleJSON, string> = {
    editor: '編集者',
    viewer: '閲覧者',
  };

  private constructor(private readonly individualPermissions: Readonly<ViewModelIndividualPermissionRolesJSON>) {}

  static buildNew(): ViewModelIndividualPermissions {
    return new this({});
  }

  static load(individualPermissions: ViewModelIndividualPermissionRolesJSON | null): ViewModelIndividualPermissions {
    return new this({ ...(individualPermissions || {}) });
  }

  dump(): ViewModelIndividualPermissionRolesJSON {
    return { ...this.individualPermissions };
  }

  entries(): [UserId, ViewModelIndividualPermissionRoleJSON][] {
    return Object.entries(this.individualPermissions);
  }

  userIds(): UserId[] {
    return Object.keys(this.individualPermissions);
  }

  getRoleOf(userId: UserId): ViewModelIndividualPermissionRoleJSON {
    const role = this.individualPermissions[userId];
    if (!role) {
      throw new Error(`No role found for userId=${userId}`);
    }

    return role;
  }

  static getLocale(role: ViewModelIndividualPermissionRoleJSON): string {
    return this.Locales[role];
  }

  static LocaleKeys: Record<ViewModelIndividualPermissionRoleJSON, ParseKeys> = {
    editor: 'workspace.memberRole.editor',
    viewer: 'workspace.memberRole.viewer',
  };

  static getLocaleKey(role: ViewModelIndividualPermissionRoleJSON): ParseKeys {
    return this.LocaleKeys[role];
  }
}
